export default "__VITE_ASSET__DfbjyuQC__"